import { render } from "./_color-picker.vue?vue&type=template&id=ff386596&lang=pug"
import script from "./_color-picker.vue?vue&type=script&lang=js"
export * from "./_color-picker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__